/* tslint:disable */
var TComboState = (function () {
    "use strict";
    var api = <any>{};

    // Overrides ComboSlipMode
    api.updateView = function () {
        TUniSlip.buildView();
    };

    // Template logic splitter
    api.buildOptions = function (selections) {
        /*globals Modes */
        Modes.calcComboVariants(this);

        /*globals TMultiOptions */
        return TMultiOptions.buildCombo(this, selections);
    };

    api.buildSelectionInnerView = function (__html, selection, selectionUpdated) {
        __html.push(TBuildLine.buildView(selection, this, { buildInner: true, updated: selectionUpdated, isSP: true }));
    };

    return api;
}());

window.TComboState = TComboState;